import { z } from 'zod';

export const CtaDTO = z.object({
    label: z.string().optional(),
    link: z.string().optional(),
});
